module.exports = __webpack_public_path__ + "img/user.0856090e.png";